import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const SeriesUnsubscribed = () => {
  const [params] = useSearchParams();
  const series = params.get("series");

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4">
        <div className="flex justify-center">
          <CheckCircle2 className="h-12 w-12 text-primary" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground">You're unsubscribed</h1>
        <p className="text-muted-foreground">
          {series
            ? `You won't receive new-event emails for "${series}" anymore.`
            : "You won't receive new-event emails for that series anymore."}
        </p>
        <p className="text-sm text-muted-foreground">
          Changed your mind? You can re-enable notifications anytime from the events page.
        </p>
        <div className="flex gap-2 justify-center pt-2">
          <Button asChild>
            <Link to="/events">Browse events</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/profile">Manage preferences</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SeriesUnsubscribed;
